// This shim is required to avoid a circular dependency when using webpack's
// ProvidePlugin to insert angular imports.

import 'angular/angular';
/* globals window */
export default window.angular;
